import { useEffect } from 'react';

/**
 * Hook to redirect from www subdomain to bare domain
 * This ensures cookies are set on the correct domain for cross-subdomain auth
 */
export function useWwwRedirect() {
  useEffect(() => {
    // Only run in production
    if (import.meta.env.PROD && typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      const appDomain = import.meta.env.VITE_APP_DOMAIN || 'terrarium.app';

      console.log('[useWwwRedirect] Current hostname:', hostname);
      console.log('[useWwwRedirect] App domain:', appDomain);

      // Add a flag to prevent redirect loops
      const isRedirectInProgress = sessionStorage.getItem(
        'www-redirect-in-progress'
      );

      if (isRedirectInProgress) {
        console.log('[useWwwRedirect] Redirect already in progress, skipping');
        return;
      }

      // If we're on www subdomain, redirect to bare domain
      if (hostname === `www.${appDomain}`) {
        const newUrl = window.location.href.replace(
          `www.${appDomain}`,
          appDomain
        );
        console.log(
          '[useWwwRedirect] Redirecting from www to bare domain:',
          newUrl
        );

        // Set flag to prevent loops
        sessionStorage.setItem('www-redirect-in-progress', 'true');

        // Use replace to avoid adding to history
        window.location.replace(newUrl);
      } else {
        // Clear the flag if we're not on www
        sessionStorage.removeItem('www-redirect-in-progress');
      }
    }
  }, []);
}
